module.exports = __webpack_public_path__ + "static/media/getDiagnostics.js.a66de606.flow";